export enum Direction {
  BACKWARD = '-',
  FORWARD = '+',
}
